module.exports = __webpack_public_path__ + "media/images/icons/Strakonice_web_ikony/kulturniMapa@3x-7e2e8ab9c65e772aaea03db3d0f8f639.png";